import { useCurrentUser } from "#/components/context/user/UserContext"
import { useQuery } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { PartnerEligibilityStatus } from "#/utils/PartnerEligibilityStatus"
import { PharmacyInfo } from "#/components/member-id/utils/pharmacyUtils"

function useMemberIdCardDetailsQuery() {
  return useQuery({
    queryKey: ["memberIdCardDetails"],
    queryFn: () => carrotClient.getMemberIdCardDetails(),
    retry: buildCarrotApiRetryPolicy(1),
    refetchOnWindowFocus: false
  })
}

export interface MemberIdCardDetails {
  publicCarrotMemberId: string
  eligibilityStartDate: string
  partnerEligibilityStatus: PartnerEligibilityStatus
  pharmacyInfo: PharmacyInfo
}

interface MemberIdInfo {
  firstName: string
  lastName: string
  isUsa: boolean
  partnerFirstName: string | undefined
  partnerLastName: string | undefined
  memberId: string
  effectiveDate: string
  isLoading: boolean
  isError: boolean
  partnerEligibilityStatus: PartnerEligibilityStatus
  pharmacyInfo: PharmacyInfo
}

export function useGetMemberIdInfo(): MemberIdInfo {
  const currentUser = useCurrentUser()
  const queryResult = useMemberIdCardDetailsQuery()
  const { data, isLoading, isError } = queryResult

  return {
    firstName: currentUser.firstName,
    lastName: currentUser.lastName,
    isUsa: currentUser.isUsa,
    partnerFirstName: currentUser.partnerFirstName,
    partnerLastName: currentUser.partnerLastName,
    memberId: data?.publicCarrotMemberId,
    effectiveDate: data?.eligibilityStartDate,
    isLoading: isLoading,
    isError: isError,
    partnerEligibilityStatus: data?.partnerEligibilityStatus,
    pharmacyInfo: {
      fertilityPharmacy: data?.pharmacyInfo.fertilityPharmacy,
      isCarrotRxActive: data?.pharmacyInfo.isCarrotRxActive,
      isCarrotRxRequired: data?.pharmacyInfo.isCarrotRxRequired
    }
  }
}
